import { render, staticRenderFns } from "./NeedsQuestion.vue?vue&type=template&id=29a2c191&scoped=true&"
import script from "./NeedsQuestion.vue?vue&type=script&lang=js&"
export * from "./NeedsQuestion.vue?vue&type=script&lang=js&"
import style0 from "./NeedsQuestion.vue?vue&type=style&index=0&id=29a2c191&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a2c191",
  null
  
)

export default component.exports